exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-to-collection{display:flex;flex-direction:column;gap:10px;max-height:50vh;overflow:hidden;padding:10px}.add-to-collection .MuiButton-sizeLarge{padding-bottom:3px;margin-bottom:5px}.add-to-collection__head-options{margin:8px 0;margin:.5rem 0;display:flex;gap:18px;justify-content:space-between}.add-to-collection__head-options .searchfield .MuiInputBase-root{min-height:0 !important}.add-to-collection__tooltip{max-width:250px;padding:5px 8px}.add-to-collection__item{min-height:60px;width:100%}.add-to-collection__item span{font-size:16px;font-size:1rem}.add-to-collection__thumb{align-items:center;display:flex;flex-direction:row;height:50px;justify-content:center;margin-right:10px;max-width:56px;overflow:hidden}.add-to-collection__thumb--collection{display:block;margin-right:10px}.add-to-collection__list .MuiList-root{height:calc(50vh - 140px);overflow-y:auto}.add-to-collection__list .MuiDivider-root{height:0}.add-to-collection .sorting-options{display:flex;flex-shrink:0}\n", ""]);

// exports
exports.locals = {
	"add-to-collection": "add-to-collection",
	"MuiButton-sizeLarge": "MuiButton-sizeLarge",
	"add-to-collection__head-options": "add-to-collection__head-options",
	"searchfield": "searchfield",
	"MuiInputBase-root": "MuiInputBase-root",
	"add-to-collection__tooltip": "add-to-collection__tooltip",
	"add-to-collection__item": "add-to-collection__item",
	"add-to-collection__thumb": "add-to-collection__thumb",
	"add-to-collection__thumb--collection": "add-to-collection__thumb--collection",
	"add-to-collection__list": "add-to-collection__list",
	"MuiList-root": "MuiList-root",
	"MuiDivider-root": "MuiDivider-root",
	"sorting-options": "sorting-options"
};